import type { Transferable } from '@app/types/common'
import type { TaskState } from '@app/types/tasks'

import { defineAll } from '@app/utils/defineAll'
import { arrayConverter, composeConverters, fromTransferable, toTransferable } from '@app/utils/jsonSerialize'
import { SerializableError } from '@app/utils/SerializableError'
import { SerializedAddress } from '@app/utils/SerializedAddress'

import { Task } from '@app/packages/task/Task'

export class StoreSerializer {
  serialize<T>(state: T) {
    return toTransferable(
      state,
      composeConverters(arrayConverter, (value, def) => {
        if (value instanceof SerializableError) return value.toJSON()
        if (value instanceof Task)
          return defineAll<TaskState>({ isTaskState: true, loadedAt: value.loadedAt.value?.format(), value: value.value.value, state: value.state.value })
        if (value instanceof Error) return undefined
        return def()
      })
    )
  }

  deserialize<T>(data: Transferable<T>): T {
    return fromTransferable(
      data,
      composeConverters(arrayConverter, (value, def) => {
        return SerializedAddress.fromDataToAddress(value) ?? SerializableError.fromData(value) ?? def()
      })
    )
  }
}
